import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { phoneCallSchema } from "common/schema";
import { getApi, postApi } from "common/services/api";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";

const AddPhoneCall = (props) => {
  const { onClose, isOpen, fetchData, setAction } = props;
  const [isLoading, setIsLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const initialValues = {
    sender: user?._id,
    recipient: "",
    callDuration: "",
    callNotes: "",
    createBy: "",
    createByLead: "",
    startDate: convertUtcToIst(new Date()),
    endDate: "",
    subject: "",
  };
  useEffect(() => {
    if (isOpen) {
      setFieldValue("startDate", convertUtcToIst(new Date()));
    }
  }, [isOpen]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: phoneCallSchema,
    onSubmit: (values, { resetForm }) => {
      AddData(resetForm);
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async (resetForm) => {
    try {
      setIsLoading(true);
      const userInfo = localStorage.getItem("user");

      const updatedVaules = {
        callOwner: userInfo ? JSON.parse(userInfo ?? "")._id : "",
        ...values,
      };
      let response = await postApi("api/phoneCall/add", updatedVaules);
      if (response.status === 200) {
        fetchData();
        toast.success("Call created successfully");
        if (setAction) setAction((pre) => !pre);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
      props.onClose();
      resetForm();
    }
  };

  const fetchDataR = async () => {
    if (props?.viewData?.lead?.leadPhoneNumber) {
      if (props.id && props.lead !== "true") {
        setFieldValue("recipient", props?.viewData?.contact?.phoneNumber);
        setFieldValue("createBy", props?.id);
        values.recipient = props?.viewData?.contact?.phoneNumber;
      } else if (props.id && props.lead === "true") {
        let response = await getApi("api/lead/view/", props.id);
        if (response?.status === 200) {
          setFieldValue("recipient", response?.data?.lead?.leadPhoneNumber);
          setFieldValue("createByLead", props.id);
          values.recipient = response?.data?.lead?.leadPhoneNumber;
        }
      }
    } else {
      if (props.id && props.lead !== "true") {
        let response = await getApi("api/contact/view/", props.id);
        if (response?.status === 200) {
          setFieldValue("recipient", response?.data?.contact?.phoneNumber);
          setFieldValue("createBy", props?.id);
          values.recipient = response?.data?.contact?.phoneNumber;
        }
      } else if (props.id && props.lead === "true") {
        let response = await getApi("api/lead/view/", props.id);
        if (response?.status === 200) {
          setFieldValue("recipient", response?.data?.lead?.leadPhoneNumber);
          setFieldValue("createByLead", props.id);
          values.recipient = response?.data?.lead?.leadPhoneNumber;
        }
      }
    }
  };

  useEffect(() => {
    fetchDataR();
  }, [props.id]);
  function onChangHeandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }
  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent maxW={"700px"}>
        <ModalHeader>{constant.createCall} </ModalHeader>
        <IconButton
          size="xs"
          className="closeIcon"
          onClick={() => {
            formik.resetForm();
            onClose();
          }}
          icon={<CloseIcon />}
        />
        <ModalBody className="modalBody">
          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.recipent}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                type="number"
                disabled
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.recipient}
                name="recipient"
                placeholder="Recipient"
                fontWeight="500"
                borderColor={
                  errors.recipient && touched.recipient ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.recipient && touched.recipient && errors.recipient}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Call Duration<Text color={"red.600"}>*</Text>
              </FormLabel>
              <InputGroup>
                <Input
                  fontSize="sm"
                  onChange={(e) => {
                    // Only allow digits (0-9)
                    const value = e.target.value.replace(/[^\d]/g, ""); // Replace non-digit characters
                    handleChange({ target: { name: e.target.name, value } }); // Update the form state
                  }}
                  onBlur={handleBlur}
                  value={values.callDuration}
                  name="callDuration"
                  placeholder="Call Duration"
                  fontWeight="500"
                  borderColor={
                    errors.callDuration && touched.callDuration
                      ? "red.300"
                      : null
                  }
                />
                <InputRightElement right={"20px"}>
                  <Text fontSize="sm" color="gray.500">
                    minutes
                  </Text>
                </InputRightElement>
              </InputGroup>
              <Text mb="10px" fontSize="sm" color={"red.600"}>
                {" "}
                {errors.callDuration &&
                  touched.callDuration &&
                  errors.callDuration}
              </Text>
            </GridItem>
            {/* <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.callDuration}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.callDuration}
                name="callDuration"
                placeholder="Call Duration"
                fontWeight="500"
                borderColor={
                  errors.callDuration && touched.callDuration ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.callDuration &&
                  touched.callDuration &&
                  errors.callDuration}
              </Text>
            </GridItem> */}
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.startDate}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.startDate}
                name="startDate"
                fontWeight="500"
                borderColor={
                  errors?.startDate && touched?.startDate ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.startDate && touched.startDate && errors.startDate}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.endDate}
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                min={values.startDate}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.endDate}
                name="endDate"
                fontWeight="500"
                borderColor={
                  errors?.endDate && touched?.endDate ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.endDate && touched.endDate && errors.endDate}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.subject} <Text color={"red.600"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={(e) => {
                  onChangHeandler(e);
                }}
                onBlur={handleBlur}
                value={values.subject}
                name="subject"
                placeholder="Enter subject"
                fontWeight="500"
                borderColor={
                  errors?.subject && touched?.subject ? "red.300" : null
                }
              />
              <Text fontSize="sm" mb="10px" color={"red.600"}>
                {" "}
                {errors.subject && touched.subject && errors.subject}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.callNotes}
              </FormLabel>
              <Textarea
                resize={"none"}
                fontSize="sm"
                placeholder="Enter Call Notes"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.callNotes}
                name="callNotes"
                fontWeight="500"
                borderColor={
                  errors.callNotes && touched.callNotes
                    ? "red.300"
                    : touched.callNotes
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.callNotes && touched.callNotes && errors.callNotes}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            className="theme-btn2 cancelBtn"
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            onClick={() => {
              formik.resetForm();
              onClose();
            }}
          >
            Close
          </Button>

          <Button
            className="theme-btn1"
            size="sm"
            variant="brand"
            disabled={isLoading ? true : false}
            onClick={handleSubmit}
          >
            {isLoading ? (
              <Spinner
                size={20}
                paddingRight={5}
                border={`3px solid ${globalStyles.colors.loaderBorder}`}
                borderTop={`1px solid ${globalStyles.colors.transparent}`}
              />
            ) : (
              ""
            )}{" "}
            {constant.save}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddPhoneCall;
